export default "__VITE_ASSET__DETG1_cz__"